var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('message-type-message',{staticClass:"forwarded",attrs:{"message":_vm.message,"shown-subscription":_vm.shownSubscription},on:{"openDocumentDrawer":_vm.openDocumentDrawer}})}
var staticRenderFns = []

export { render, staticRenderFns }